"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Claims = void 0;
const jwt_1 = require("@ew-did-registry/jwt");
const models_1 = require("../models");
const utils_1 = require("../utils");
const proofVerifier_1 = require("../claimsVerifier/proofVerifier");
/**
 * @class
 * Base class for extending by other claims classes
 */
class Claims {
    /**
     * @constructor
     *
     * @param { IKeys } keys
     * @param document
     * @param store
     */
    constructor(owner, document, store) {
        this.document = document;
        this.store = store;
        this.keys = { publicKey: owner.publicKey, privateKey: owner.privateKey };
        this.jwt = new jwt_1.JWT(owner);
        this.did = document.did;
    }
    /**
     * Verifies issuance and publishing of claim at `claimUrl`.
     * On success returns claim.
     * Verification takes into account purpose on which claim was issued.
     *
     * @param claimUrl: Url of claim to be verified. This method will retrieve
     * the claim using the didStore configured for the class
     * @param params.hashFns: The function used to determine the of hash of the claim
     * token used in the DID document. Used to verify that the DID document service endpoint
     * matches the retrieved claim.
     * @param params.issuerDoc: Document with verification methods to verify claim issuance with
     * @param params.holderDoc: Document with service endpoints to verify claim publishing with
     * @param params.verificationPurpose: Specifies which verification methods to use.
     * `VerificationPurpose.Authenticate` is used to verify claim issued to authenticate identity
     * `VerificationPurpose.Assertion` is used to assert issuer approval.
     * By default verification asserts claim approval.
     *
     */
    verify(claimUrl, { hashFns, issuerDoc, holderDoc, verificationPurpose = models_1.VerificationPurpose.Assertion, } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.store.get(claimUrl);
            const claim = this.jwt.decode(token);
            if (!issuerDoc) {
                issuerDoc = yield this.document.read(claim.iss);
            }
            if (!holderDoc) {
                holderDoc = yield this.document.read(claim.sub);
            }
            yield this.validateServiceEndpointToken(claimUrl, {
                hashFns,
                holderDoc,
            });
            const proofVerifier = new proofVerifier_1.ProofVerifier(issuerDoc);
            switch (verificationPurpose) {
                case models_1.VerificationPurpose.Authentication:
                    if (yield proofVerifier.verifyAuthenticationProof(token)) {
                        return claim;
                    }
                    break;
                case models_1.VerificationPurpose.Assertion:
                    if (yield proofVerifier.verifyAssertionProof(token)) {
                        return claim;
                    }
                    break;
                default:
                    break;
            }
            throw new Error('Token is not verified');
        });
    }
    /**
     * @description Verifies that token stored at `claimUrl` is one of the services of `holderDoc`.
     *
     * @param claimUrl: url of the published claim
     * @param params.hashFns: The function used to determine the of hash of the claim
     * token used in the DID document. Used to verify that the DID document service endpoint
     * matches the retrieved claim.
     * @param params.holderDoc: Document in which to search for service endpoint.
     */
    validateServiceEndpointToken(claimUrl, { hashFns, holderDoc, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.store.get(claimUrl);
            const service = holderDoc.service.find((s) => s.serviceEndpoint === claimUrl);
            if (!service) {
                throw new Error(`No service endpoint found for ${claimUrl} in holder DID document`);
            }
            const { hash, hashAlg } = service;
            const createHash = Object.assign(Object.assign({}, utils_1.hashes), hashFns)[hashAlg];
            if (hash !== createHash(token)) {
                throw new Error(`Claim at ${claimUrl} was changed`);
            }
        });
    }
}
exports.Claims = Claims;
//# sourceMappingURL=claims.js.map